import { Route } from '@angular/router'
import { authGuard, groupTypeGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type BusinessRoutes = {
    inventory: Route
    financial: Route
    discounts: Route
}

export const businessRoutes: BusinessRoutes = {
    inventory: {
        path: 'dashboard/inventory',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/inventory'],
            }),
            permissionGuard([PERMISSIONS.inventory.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-inventory/page-inventory.component').then(
                (m) => m.PageInventoryComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    financial: {
        path: 'dashboard/financial',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/financial'],
            }),
            permissionGuard([PERMISSIONS.finance.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-financial/page-financial.component').then(
                (m) => m.PageFinancialComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
    discounts: {
        path: 'dashboard/discounts',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            groupTypeGuard({
                groupType: 'vendor',
                redirectTo: ['/dashboard/client/discounts'],
            }),
            permissionGuard([PERMISSIONS.discount.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-discounts/page-discounts.component').then(
                (m) => m.PageDiscountsComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
